import Chip from '@/components/shared/Chip';
import { ShiftStatusWithdrawAllowed } from '@instapaid/shared-logic';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface StatusProps {
    status?: string;
    shiftStatusWithdrawAllowed?: ShiftStatusWithdrawAllowed;
    availableForPayout?: boolean;
    isShiftTypeExcluded?: boolean;
}

export const Status = ({
    status,
    shiftStatusWithdrawAllowed,
    availableForPayout,
    isShiftTypeExcluded
}: StatusProps) => {
    const { t } = useTranslation();

    let statusText = t(status!);

    if (isShiftTypeExcluded) {
        statusText = t('excluded');
    }

    const statusColor = useMemo(() => {
        if (isShiftTypeExcluded || !availableForPayout) {
            return 'warning';
        }
        if (
            shiftStatusWithdrawAllowed == ShiftStatusWithdrawAllowed.Registered
        ) {
            return 'success';
        }

        if (shiftStatusWithdrawAllowed == ShiftStatusWithdrawAllowed.Approved) {
            if (status === 'Approved') {
                return 'success';
            } else {
                return 'info';
            }
        }

        if (
            shiftStatusWithdrawAllowed ==
            ShiftStatusWithdrawAllowed.PunchclockFinished
        ) {
            if (status === 'PunchclockStarted') {
                return 'info';
            } else if (
                status === 'PunchclockFinished' ||
                status === 'Approved'
            ) {
                return 'success';
            } else {
                return 'info';
            }
        }
    }, [status, shiftStatusWithdrawAllowed]);

    return <Chip color={statusColor} label={statusText} />;
};
